import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { setOrderSeller, toggleModal } from '../sellCommoditySlice'

import PMBTotalFooter from 'components/PMBTotalFooter'
import { useEffect } from 'react'

const InfoTotalAmount = ({ isLoading, isSuccess, data }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { orders, invPacking } = useSelector((s) => s.sellCommodity)

  const safeOrders = orders?.item?.filter(Boolean) ?? []
  const safePacking = invPacking?.filter(Boolean) ?? []

  const total =
    safeOrders
      .filter((item) => !item?.isPacking)
      .map((item) => {
        const price = Number(item?.totalPrice)
        return isNaN(price) ? 0 : price
      })
      .reduce((sum, price) => sum + price, 0) +
    safePacking
      .map((item) => {
        const price = Number(item?.totalPrice)
        return isNaN(price) ? 0 : price
      })
      .reduce((sum, price) => sum + price, 0)

  let updatedOrders = safeOrders.map((item) => ({
    ...item,
    price: item.price || '0',
    totalPrice: item.totalPrice || '0',
  }))

  let checkUnits = updatedOrders?.map((i, idx) => {
    if (i.isPacking) {
      return false
    }

    const item = updatedOrders[idx]
    const requiredFields = ['nameItem', 'amount', 'unit', 'price']

    for (const key of requiredFields) {
      const val = item[key]
      if (
        val === undefined ||
        val === '' ||
        val === null ||
        (key === 'amount' && val === '0')
      ) {
        return true
      }
    }

    return false
  })

  useEffect(() => {
    if (isSuccess)
      dispatch(
        setOrderSeller({
          fullName: data?.ownerData?.name,
          phoneNumber: data?.ownerData?.phoneNumber,
          email: data?.ownerData?.email,
          userId: data?.ownerData?.userId,
          ...(data?.ownerData?.otherPicUser && {
            otherPicUserId: data?.ownerData?.otherPicUser?.userId,
          }),
        }),
      )
  }, [dispatch, data, isSuccess])

  return (
    <>
      <PMBTotalFooter
        total={total}
        testId="sell-form"
        isDisable={
          (isLoading ||
            !orders?.buyer ||
            checkUnits.includes(true) ||
            orders?.isLoading) &&
          !location.state?.isManual
        }
        onSubmit={() => dispatch(toggleModal())}
      />
    </>
  )
}

export default InfoTotalAmount
